class FGFeaturedCollections extends HTMLElement {
    connectedCallback() {
        this.tabContainer = this.querySelector('.fg-featured-collections__tabs');
        this.carousels = this.querySelectorAll('.fg-featured-collections__panels fg-carousel[data-tab-label]');

        if (this.carousels.length === 0) return;

        this.carousels.forEach((carousel, index) => {
            const tab = document.createElement('button');
            tab.type = 'button';
            tab.setAttribute('role', 'tab');
            tab.className = 'fg-featured-collections__tab';
            tab.textContent = carousel.dataset.tabLabel;
            tab.dataset.tabIndex = index;
            tab.setAttribute('aria-selected', index === 0);

            if (index === 0) {
                tab.classList.add('fg-featured-collections__tab--active');
                carousel.classList.add('fg-featured-collections__panel--active');
                requestAnimationFrame(() => carousel.update());
            }

            tab.addEventListener('click', () => this.#switchTab(index));
            this.tabContainer.appendChild(tab);
        });

        this.tabContainer.addEventListener('keydown', (e) => this.#handleKeydown(e));
    }

    /**
     * @param {number} activeIndex
     */
    #switchTab(activeIndex) {
        const tabs = this.querySelectorAll('.fg-featured-collections__tab');

        tabs.forEach((tab, index) => {
            const isActive = index === activeIndex;
            tab.classList.toggle('fg-featured-collections__tab--active', isActive);
            tab.setAttribute('aria-selected', isActive);
        });

        this.carousels.forEach((carousel, index) => {
            const isActive = index === activeIndex;
            carousel.classList.toggle('fg-featured-collections__panel--active', isActive);
            if (isActive) {
                requestAnimationFrame(() => carousel.update());
            }
        });
    }

    /**
     * @param {KeyboardEvent} e
     */
    #handleKeydown(e) {
        const tabs = [...this.querySelectorAll('.fg-featured-collections__tab')];
        const currentIndex = tabs.findIndex((tab) => tab.classList.contains('fg-featured-collections__tab--active'));

        let newIndex;
        if (e.key === 'ArrowRight') {
            newIndex = (currentIndex + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft') {
            newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else {
            return;
        }

        e.preventDefault();
        this.#switchTab(newIndex);
        tabs[newIndex].focus();
    }
}

if (!customElements.get('fg-featured-collections')) {
    customElements.define('fg-featured-collections', FGFeaturedCollections);
}
